import { getManufacturerByProgram } from "@/libs/util";
import { programLabels } from "@/config";
// eslint-disable-next-line react/prop-types
const Koate = ({ name, themeColor, supportPhone }) => {
  return (
    <>
      <div className="mx-auto py-10">
        <div className="text-xl md:text-3xl font-bold text-[#000000]">
          <span style={{ color: themeColor }}>{programLabels[name].name}</span>
          &nbsp; SUPPORT FOR PATIENTS
        </div>

        <div className="mt-10 text-2xl font-bold">COPAY ASSISTANCE</div>

        <p className="my-2 font-bold">
          Eligible patients can receive up to $15,000 over 12 months to cover the deductible, copay, and/or coinsurance for KOĀTE.
        </p>

        <ul className="my-2 list-disc ml-10">
          <li>
            Please ask your provider to bill Medmonk for your copay assistance at the time of dispensing. This
            streamlined approach facilitates the process, ensuring prompt access to the copay assistance you need.
          </li>
          <li>
            KOĀTE copay assistance can typically be used regardless of whether your healthcare provider is billing through your major medical plan or your pharmacy benefits.
          </li>
        </ul>

        <div className="mt-10 font-bold">ELIGIBILITY CRITERIA FOR COPAY ASSISTANCE
        </div>

        <ul className="my-2 list-disc ml-10">
          <li>Patients must be commercially insured.</li>
          <li>
            Patients must express a financial need.
          </li>
          <li>
            Assistance available for the treatment of patients requiring KOĀTE for Hemophilia A.
          </li>
        </ul>

        <div className="font-bold">RESTRICTIONS</div>

        <ul className="my-2 list-disc ml-10">
          <li>
            Not valid for prescriptions eligible for reimbursement by any federal or state healthcare programs, such as Medicare, Medicaid, Medigap, Veterans Affairs, Department of Defense, Tricare, or any other federal or state-funded programs.
          </li>
        </ul>

        <div className="mt-10 text-2xl font-bold">REIMBURSEMENT SUPPORT</div>

        <p className="my-2">
          Feel free to contact our Support Team at <a className="text-blue-500 hover:text-blue-600 hover:underline" href={`tel:${supportPhone}`}>{supportPhone}</a> and inquire about your insurance coverage. We're here to help you navigate your coverage and provide support where needed.
        </p>

        <div className="mt-10 text-2xl font-bold">CLINICAL SUPPORT</div>

        <p className="my-2">
          Please visit https://www.mykoate.com/using-koate/ for instructions on how to use KOĀTE and storage and handling instructions.
        </p>

        <div className="mt-10">
          This program is subject to change or discontinuation by&nbsp;
          <b>{getManufacturerByProgram(name)}</b>
          &nbsp;at any time, for any reason, and with or without prior notice.
          This portal is administered by&nbsp;
          <a target="_blank" href="https://medmonk.com/" className="text-blue-500 hover:underline">Medmonk</a>
          &nbsp;for the {programLabels[name].label} Program.
        </div>
      </div>
    </>
  )
}

export default Koate